import React, { Component } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import renderHTML from "react-render-html";
import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import "./Risk.scss";
import "./risk.css";
import "./Risk.styles.scss";

class Risk extends Component {
  state = {
    // render: true,
    // popUp: false,
    // portfolioId: this.props,
    // UniqueID: 0,
    // all portfolio template data
    // TempData: {},
    // concatedData: {},
    // renderTemplateTable: false,
    // callApiOne: true,
  };
  componentWillMount() {
    const { setUniverseLiteSymbols } = this.props;
    setUniverseLiteSymbols([]);
  }
  componentDidMount() {
    const {
      // setUniverseLiteSymbols,
      modelportfolios,
      setLitePortfolioActive,
    } = this.props;

    setLitePortfolioActive(false);
    // setting default data as BSE-500
    // BacktestService.getScenarioShortlist("988").then((data) => {
    //   setUniverseLiteSymbols(data);
    // });

    // for template api call
    if (modelportfolios.length) {
      var listOfID = [];
      modelportfolios.map((e) => listOfID.push(e["data"][0].scenario_id));
    }
  }

  // componentWillReceiveProps() {
  // const { modelportfolios } = this.props;
  // if (this.state.render === true) {
  //   // for template api call
  //   if (modelportfolios.length) {
  //     var listOfID = [];
  //     var data = modelportfolios.map((e) =>
  //       listOfID.push(e["data"][0].scenario_id)
  //     );
  //     //  api call based on list of ids
  //     if (
  //       listOfID.length &&
  //       this.state.callApiOne &&
  //       Object.keys(this.props.templateData).length === 0
  //     ) {
  //       for (let i = 0; i < listOfID.length; i++) {
  //         var concatData = Object.assign({}, this.state.TempData);

  //         BacktestService.getScenarioShortlist(`${listOfID[i]}`, "CI").then(
  //           (data) => {
  //             let obj = (concatData[`${listOfID[i]}`] = data);
  //             this.setState({
  //               TempData: obj,
  //               concatedData: concatData,
  //             });
  //             this.props.setTemplateTables(concatData);
  //           }
  //         );
  //       }
  //       this.setState({
  //         callApiOne: false,
  //       });
  //     }
  //   }
  // }
  // }
  highlightSelectedButton = (e) => {
    if (this.props.portfolioActive == false && this.props.symbols.length > 0) {
      var allScenarios = document.getElementsByClassName("scenario-button");
      for (var i = 0; i < allScenarios.length; i++) {
        allScenarios[i].style.color = "black";
        allScenarios[i].style.backgroundColor = "white";
      }
    }
  };
  // button handler
  buttonHandler(e, mp) {
    this.props.setActiveGoal(mp);
    this.props.setPortfolioID(e.target.value);
    this.props.setBenchmarkName(e.target.name);
    this.props.setSymbols([]);
    this.props.setInitialTableData([]);
    this.props.cloneStyles(mp.data[0].styles);
    this.highlightSelectedButton(e.target.value);

    this.props.nextStepCallBack(true);
    this.props.setSecuritiesValidToNextStep(true);

    // inactive universe lite
    this.props.setLitePortfolioActive(false);
  }

  render() {
    const { modelportfolios } = this.props;

    return (
      <div className="risk">
        {modelportfolios && modelportfolios.length > 0 ? (
          <div className="select_risk_portfolio">
            {modelportfolios.map((mp, i) => (
              <div className="risk_card_holder" key={i}>
                <div
                  className="risk_card_image"
                  style={{
                    backgroundImage:
                      "url(/images/" + mp.data[0].img_name + ".jpg)",
                  }}
                >
                  <div className="risk_card_image_content">
                    <span className="risk_card_image_title">
                      {mp.data[0].text1}
                    </span>
                  </div>
                </div>
                <div className="risk_card_maincontent">
                  <p className="risk_card_sub_heading">{mp.data[0].text2}</p>
                  <p className="risk_card_content">
                    {renderHTML(
                      mp.data[0]["description"]
                        ? mp.data[0]["description"]
                        : mp.data[0]["text1"]
                    )}
                  </p>
                </div>

                <div className="risk_card_btn_rangeholder">
                  <div>
                    <button
                      type="button"
                      className="risk_btn text-uppercase"
                      value={mp.data[0].scenario_id}
                      name={mp.data[0].benchmark_name}
                      id={"selectedScenario_" + mp.data[0].scenario_id}
                      onClick={(e) => this.buttonHandler(e, mp)}
                    >
                      start with this Portfolio{" "}
                      <i className="fa fa-angle-right" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="risk__spinner">
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      json,
      steps: {
        risk: { active, activePortfolioID, templateData },
        backendParams: {
          optimization_params: { max_vol, min_return, upper_bounds },
        },
        universe: { symbols },
        universeLite: { portfolio, portfolioActive, lite_symbols },
      },
      steps,
      modelportfolios,
      cloneModelportfolios,
    },
  }) => ({
    active,
    ui_params: json,
    modelportfolios,
    steps,
    activePortfolioID,
    max_vol,
    min_return,
    upper_bounds,
    scenarioName: steps.risk.scenarioName,
    displayPopUp: steps.risk.displayPopUp,
    portfolioActive,
    portfolio,
    lite_symbols,
    symbols,
    cloneModelportfolios,
    templateData,
  }),
  (dispatch) => ({
    setPortfolioID: (payload) =>
      dispatch({ type: "SET_PORTFOLIO_ID", payload }),
    setActiveGoal: (inv) => dispatch({ type: "SET_ACTIVE_GOAL", payload: inv }),
    setPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    // initial table data and cloned table data of step2 clearing
    setSymbols: (payload) => dispatch({ type: "SET_UNIVERSE_DATA", payload }),
    setInitialTableData: (payload) =>
      dispatch({ type: "SET_INITIAL_TABLE_DATA", payload }),
    setLitePortfolioActive: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_ACTIVE", payload }),
    setSecuritiesValidToNextStep: (payload) =>
      dispatch({ type: "SET_UNIVERSE_SECURITYVALIDITY", payload }),

    // setting BSE 500 data as symbols
    setUniverseLiteSymbols: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_SYMBOLS", payload }),

    // set cloned data for universe sliders
    cloneStyles: (payload) =>
      dispatch({ type: "SET_UNIVERSE_CLONE_STYLES", payload }),
    // set template tables
    setTemplateTables: (payload) =>
      dispatch({ type: "SET_RISKTABLE_TEMPLATES", payload }),
  })
)(Risk);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Risk.jsx